import {useContext} from "react";
import {GlobalContext} from "../utils/context";

const ManagerTable = ({selectedUser, selectedManager, setSelectedManager}) => {
	const {managers} = useContext(GlobalContext);
	return <div className="table-container">
		<table>
			<thead>
			<tr>
				<td>Name</td>
				<td>User</td>
				<td>Alerts</td>
				<td>Triggers in Month</td>
				<td>Subscribers</td>
			</tr>
			</thead>
			<tbody>
			{
				managers.filter(m=>!selectedUser || m.owner===selectedUser).map((manager) => {
					const selected = manager._id === selectedManager;
					return <tr
						key={manager._id} onClick={()=>setSelectedManager(selected?null:manager._id)}
						className={selected ? 'selected-tr' : ''}
					>
						<td>{manager.name}</td>
						<td>{manager.userEmail}</td>
						<td>{manager.alerts}</td>
						<td>{manager.triggers}</td>
						<td>{manager.subscribers.length}</td>
					</tr>
				})
			}
			</tbody>
		</table>
	</div>
}

export default ManagerTable;